import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/eula")({
  head: () => ({
    meta: [
      { title: "End User License Agreement, Square Migration" },
      {
        name: "description",
        content:
          "End User License Agreement for Square Migration websites, applications, and digital tools.",
      },
      { property: "og:title", content: "End User License Agreement, Square Migration" },
      {
        property: "og:description",
        content:
          "End User License Agreement for Square Migration websites, applications, and digital tools.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: EulaPage,
});

function EulaPage() {
  return (
    <main className="min-h-screen bg-background px-6 py-20 md:py-24">
      <article className="max-w-3xl mx-auto prose prose-invert">
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
          End User License Agreement
        </h1>

        <p className="text-muted-foreground">
          Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
        </p>

        <section className="mt-8">
          <h2 className="text-xl font-semibold text-foreground">1. Acceptance of Terms</h2>
          <p className="text-muted-foreground mt-2">
            This End User License Agreement (“Agreement”) is a legal agreement between you (“User” or “you”) and Square Migration (“we,” “us,” or “our”). By accessing, downloading, installing, or using any website, application, tool, or other digital property provided by Square Migration, you agree to be bound by this Agreement.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">2. License Grant</h2>
          <p className="text-muted-foreground mt-2">
            Subject to your compliance with this Agreement, Square Migration grants you a limited, non-exclusive, non-transferable, revocable license to access and use our digital properties for your personal or internal business purposes.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">3. Restrictions</h2>
          <p className="text-muted-foreground mt-2">You may not:</p>
          <ul className="list-disc pl-5 mt-2 text-muted-foreground space-y-1">
            <li>Copy, modify, distribute, sell, or lease any part of our services</li>
            <li>Reverse engineer, decompile, or disassemble any software or code</li>
            <li>Use our services for unlawful, harmful, or fraudulent purposes</li>
            <li>Interfere with or disrupt the integrity or performance of our services</li>
            <li>Attempt to gain unauthorized access to our systems or user accounts</li>
          </ul>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">4. Intellectual Property</h2>
          <p className="text-muted-foreground mt-2">
            All content, designs, code, trademarks, and other materials provided by Square Migration are owned by Square Migration or its licensors and are protected by intellectual property laws. This Agreement does not transfer any ownership rights to you.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">5. User Content</h2>
          <p className="text-muted-foreground mt-2">
            You retain ownership of any content you submit through our services. By submitting content, you grant Square Migration a limited license to use, host, and display that content solely for the purpose of providing the services to you.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">6. Termination</h2>
          <p className="text-muted-foreground mt-2">
            We may suspend or terminate your access at any time, with or without notice, if you violate this Agreement or for any other business reason. Upon termination, all licenses granted to you will immediately cease.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">7. Disclaimer of Warranties</h2>
          <p className="text-muted-foreground mt-2">
            Our services are provided “as is” and “as available” without warranties of any kind, either express or implied. We do not guarantee that our services will be uninterrupted, secure, or error-free.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">8. Limitation of Liability</h2>
          <p className="text-muted-foreground mt-2">
            To the fullest extent permitted by law, Square Migration shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our services.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">9. Governing Law</h2>
          <p className="text-muted-foreground mt-2">
            This Agreement shall be governed by and construed in accordance with the laws of the State of Minnesota, without regard to its conflict of law principles.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">10. Changes to This Agreement</h2>
          <p className="text-muted-foreground mt-2">
            We may update this Agreement from time to time. Continued use of our services after changes are posted constitutes acceptance of the revised Agreement.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold text-foreground">11. Contact Us</h2>
          <p className="text-muted-foreground mt-2">
            If you have questions about this Agreement, please contact us at{" "}
            <a
              href="mailto:chris@squaremigration.com"
              className="text-primary hover:underline"
            >
              chris@squaremigration.com
            </a>
            .
          </p>
        </section>
      </article>
    </main>
  );
}
